import React from 'react';

import { BaseIconProps } from '.';

export const DiameterThick = ({ fill }: BaseIconProps) => {
  return (
    <>
      <g fill={fill} transform="translate(0.505,0.055)">
        <path d="M 551.5,218.2 C 380.6,218.2 242,356.8 242,527.7 242,698.6 380.6,837.2 551.5,837.2 722.4,837.2 861,698.7 861,527.7 861,356.7 722.4,218.2 551.5,218.2 m 0,-132.6 c 244.2,0 442.1,197.9 442.1,442.1 0,244.2 -197.9,442.2 -442.1,442.2 -244.2,0 -442.1,-198 -442.1,-442.2 0,-244.2 197.9,-442.1 442.1,-442.1 z" />
        <path d="M 97.4,1031.2 8.9,933 981.6,48.7 1070,146.9 Z" />
      </g>
    </>
  );
};
